import { User } from './../models/user';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { first, firstValueFrom, lastValueFrom, observable, Observable, take, throwError } from 'rxjs';
import { AppConfigService } from '../app.config.service';
import { AuthService } from '@auth0/auth0-angular';
import { ApprovalStatus } from '../models/ApprovalStatus';
import { GroupLeaderApprovalResponse } from '../models/GroupLeaderApprovalResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})

export class UserService {
  private http: HttpClient;
  private configId: string;
  public groupLeaderAccountIsSelected: boolean = false;
  public user: User;
  constructor(
    @Inject(HttpClient) http: HttpClient,
    public auth: AuthService,
    private appConfigService: AppConfigService) {
    this.http = http;
  }

  generateUserFromAccount(idpAccount: any): Observable<boolean> {

    return new Observable(observer => {
      if(this.user && this.user.last_updated_at == idpAccount.updated_at){
          observer.next(true); 
          observer.complete();
          return;
      }
      let user = new User();
      if (idpAccount) {
        
        user.userId = idpAccount.sub;
        user.email = idpAccount.email

        if (idpAccount.is_Broker) {
          user.AddBrokerUserType();
          user.isActivatedBroker = idpAccount.is_Activated;
          user.firstName = idpAccount.given_name;
          user.lastName = idpAccount.family_name;
          user.last_updated_at = idpAccount.updated_at;
          this.user = user;
          observer.next(true); 
          observer.complete();
          return;
        }
        else if (idpAccount.is_group_leader) {
          this.http.get(`${this.appConfigService.AppConfig.apiUrl_glp}/RetrieveGroupLeaderData`, {
            params: new HttpParams()
              .set('email', idpAccount.email)
          })
          .subscribe((result) => { 
            user.AddGroupLeaderUserType();
            user.phoneNumber = idpAccount.phone_number;
            user.isEHA = idpAccount.is_group_leader_eha;
            user.firstName = idpAccount.first_name;
            user.lastName = idpAccount.last_name;
            user.last_updated_at = idpAccount.updated_at;
            let groupIds = result["groupLeader"].groupLeaderAccounts.map(n => n.groupId)
            user.accountNumber = groupIds.join(',');

            this.user = user;

            observer.next(true); 
            observer.complete(); 
          },
          (error) => { 
            observer.error(error);
            observer.complete();
          } 
        );
        }
        else {
          this.user = user;
          observer.next(false); 
          observer.complete();
          return;
        }
      }
    });
  }

  getGroupLeaderData(email: string): Observable<any> {
    return this.http.get(`${this.appConfigService.AppConfig.apiUrl_glp}/RetrieveGroupLeaderData`, {
      params: new HttpParams()
        .set('email', email)
    });
  }

  getUserGroup(groupId: string): Observable<any> {
    return this.http.get(`${this.appConfigService.AppConfig.apiUrl_glp}/GroupName`, {
      params: new HttpParams()
        .set('groupid', groupId)
    });
  }

  getAuth0ClientId = () => {
    // development logic
    if(document.baseURI.includes('localhost')){
      if(environment.redirectUrlBroker.includes('localhost')){
        return environment.auth0BrokerclientId
      }
      else if (environment.redirectUrlGL.includes('localhost')){
        return environment.auth0GLclientId ;
      }
    }


    if(document.baseURI.includes('broker')){
      return environment.auth0BrokerclientId;
    }
    else{
      return environment.auth0GLclientId ;
    }
  };

  resetUserPassword(): Observable<any> {
    
    return new Observable(observer => {
      let requestBody = {
        client_id: this.getAuth0ClientId(),
        email: this.user.email,
        connection: 'BCBSNE'
      };
      let apiDomain = environment.auth0APIDomain;
      let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/json');
      
      this.http.post(`https://${apiDomain}/dbconnections/change_password`, requestBody,{ headers: headers } )
        .subscribe((result) => { 
          observer.next(true); 
          observer.complete(); 
        },
        (error) => {
          // Not sure why auth0 is returning an error when its 200 status code but its working 
          if(error.status == 200){
            observer.next(true);
          }
          else{
            observer.error(error);
          }
          observer.complete();
        });
    });
  }

  

  getMAApplicationStatuses(): Observable<any> {
    return new Observable(observer => {
      this.http.get(`${this.appConfigService.AppConfig.apiUrl_glp}/MAApplicationStatus`, {
        params: new HttpParams()

          .set('email', this.user.email)
      }).subscribe((result) => { observer.next(result); observer.complete(); });
    });
  }


  GetBrokerGroups(): Observable<any> {
    return new Observable(observer => {
      this.http.get(`${this.appConfigService.AppConfig.apiUrl_glp}/BrokerGroups`, {
        params: new HttpParams()
          .set('email', this.user.email),
        observe: 'response'
      }).subscribe(
      (result) => {
        let retObject = {};
        retObject["status"] = result.status;
        retObject["success"] = result.ok;
        retObject["retList"] = result.body['retList'];
        observer.next(retObject);
        observer.complete();
      },
      (error) => {
        let result = {};
        result["success"] = false;
        result["status"] = error.status;
        observer.next(result);
        -observer.complete();
      });
    });
  }
  
  getGroupLeaderApprovalStatus(): Observable<GroupLeaderApprovalResponse> {
    return new Observable(observer => {
      if (this.user.IsGroupLeader()) {
        this.http.get<string[]>(`${this.appConfigService.AppConfig.apiUrl_glp}/IsEmployeeApproved`, {
          params: new HttpParams()
            .set('email', this.user.email)
            .set('accountNumber', this.user.accountNumber)
        }).subscribe((result) => {

          let groupLeaderApprovalResponse = new GroupLeaderApprovalResponse();
          groupLeaderApprovalResponse.isApproved = JSON.parse(result[0].toLowerCase());
          //groupLeaderApprovalResponse.accountType = result[1].toUpperCase();

          observer.next(groupLeaderApprovalResponse);
          observer.complete();
        },
        (error) => {
          let groupLeaderApprovalResponse = new GroupLeaderApprovalResponse();
          groupLeaderApprovalResponse.isApproved = false;

          observer.next(groupLeaderApprovalResponse);
          observer.complete();
        });

      } else {
        let groupLeaderApprovalResponse = new GroupLeaderApprovalResponse();
        groupLeaderApprovalResponse.isApproved = false;

        observer.next(groupLeaderApprovalResponse);
        observer.complete();
      }
    });
  }

  getBrokerApprovalStatus(): ApprovalStatus {
    let approvalStatus = new ApprovalStatus();
    approvalStatus.isApproved = false;

    if (this.isBrokerUser()) {
      approvalStatus.isApproved = this.user.isActivatedBroker;
    }

    return approvalStatus;
  }

  getGroupLeaderGroups(userEmail: string, groupIDs: string): Observable<any> {
    return new Observable(observer => {
      this.http.get(`${this.appConfigService.AppConfig.apiUrl_glp}/GroupLeaderGroups`, {
        params: new HttpParams()
          .set('email', userEmail)
          .set('groupId', groupIDs)
      }).subscribe((result) => { observer.next(result); observer.complete(); });
    });
  }

  getIndividualList(email: string): Observable<any> {
    return new Observable(observer => {
      this.http.get(`${this.appConfigService.AppConfig.apiUrl_glp}/IndvSubscriptions`, {
        params: new HttpParams()
          .set('email', email)
      }).subscribe((result) => { observer.next(result); observer.complete(); });
    });
  }

  isBrokerUser(): boolean {
    return this.user ? this.user.IsBroker() : false;
  }

  isGroupLeaderUser(): boolean {
    return this.user ? this.user.IsGroupLeader() : false;
  }

  isGroupLeaderEHAUser(): boolean {
    return this.user.isEHA;
  }

  setGroupLeaderAccountIsSelected(value: boolean): void {
    this.groupLeaderAccountIsSelected = value;
  }

  isGroupLeaderAccountSelected(): boolean {
    return this.groupLeaderAccountIsSelected;
  }

  hasTopAccount(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.auth.getAccessTokenSilently().subscribe({
        next: (token: string) => {
          try {
            // Decode JWT token to get payload
            const payload = token.split('.')[1];
            const decodedPayload = JSON.parse(atob(payload));
            const asoTopAccount = decodedPayload.aso_top_account;
            const hasTopAccount = asoTopAccount !== undefined && 
                                  asoTopAccount !== null && 
                                  (!Array.isArray(asoTopAccount) || asoTopAccount.length > 0);
            resolve(hasTopAccount);
          } catch (error) {
            console.error('Failed to decode token:', error);
            reject(error);
          }
        },
        error: (err) => {
          console.error('Failed to get token:', err);
          reject(err);
        }
      });
    });
  }
}
